import React from "react";
import UserProfileMenu from "../UserProfile/UserProfileMenu";
import BranchSelector from "./BranchSelector";
import BranchContractAlert from "../BranchContract/BranchContractAlert";

/**
 * 與 NewHeader 右上角「人像 + 分店」一致。
 * - default：套 global-ld 位移（僅適用全域 NewHeader 麵包屑列）
 * - sales：銷售頂列，不位移
 * - accounting-toolbar：帳務內頁自訂 72px 頂列，勿套 global-ld（否則會向左下偏）
 */
function HeaderUserBranchCluster({ variant = "default" }) {
  const isSalesToolbar = variant === "sales";
  const isAccountingToolbar = variant === "accounting-toolbar";

  const clusterClass = (() => {
    const base =
      "new-header__user-branch-cluster d-flex justify-content-end align-items-center";
    if (isSalesToolbar || isAccountingToolbar) {
      return `${base} new-header__user-branch-cluster--flush`;
    }
    return `${base} branch-select-slot-nudge branch-select-slot-nudge--global-ld`;
  })();

  return (
    <div className={clusterClass}>
      <BranchContractAlert />
      <UserProfileMenu className="me-1" />
      <BranchSelector showUserProfile={false} />
    </div>
  );
}

export default HeaderUserBranchCluster;
